//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'

export default {
  name: 'CookieSidebar',
  data: () => ({
    essential: true,
    optional: true
  }),
  computed: {
    ...mapGetters({
      visible: 'page/showCookieModal',
      cookiesAllowed: 'page/cookiesAllowed'
    })
  },
  beforeMount () {
    this.optional = this.cookiesAllowed === null ? true : this.cookiesAllowed
  },
  methods: {
    close () {
      this.$store.dispatch('session/UPDATE', { allow_cookies: this.optional ? 'allow' : 'deny' })
      this.$store.commit('page/SET_COOKIE_STATUS', this.optional)
      this.$store.commit('page/SET_COOKIE_MODAL_STATE', false)
    }
  }
}
